<template>
  <section class="table-sampler-characterization" >

    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>N.º da amostra</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º da amostra"
          v-model="model.sample_no"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>GHE</label>
        <input
          type="text"
          class="form-control"
          placeholder="GHE"
          v-model="model.ghe"
          required
        />
      </d-col>
      <d-col cols="7">
        <label>Supervisor</label>
        <input
          type="text"
          class="form-control"
          placeholder="Supervisor"
          v-model="model.supervisor"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12" md="9">
        <label>Funcionário</label>
        <input
          type="text"
          class="form-control"
          placeholder="Funcionário"
          v-model="model.employee"
          required
        />
      </d-col>
      <d-col cols="12" md="3">
        <label>Registro</label>
        <input
          type="text"
          class="form-control"
          placeholder="Registro"
          v-model="model.register"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12" md="4">
        <label>Função</label>
        <input
          type="text"
          class="form-control"
          placeholder="Função"
          v-model="model.function"
          required
        />
      </d-col>
      <d-col cols="12" md="4">
        <label>Setor</label>
        <input
          type="text"
          class="form-control"
          placeholder="Setor"
          v-model="model.sector"
          required
        />
      </d-col>
      <d-col cols="12" md="4">
        <label>Máquina/Equipamento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Máquina/Equipamento"
          v-model="model.equipment"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row v-if="model.files && model.files.length" class="px-4 pt-2">
      <picture v-for="(file, index) in model.files" :key="file.id">
        <i class="fas fa-trash delete-img" @click="deleteFile(index)"></i>
        <img
          :src="`${file.url}/?w=150&h=150`"
          :alt="file.name"
          @click="previewImage(index)"
          style="cursor: pointer;"
        />
        <h5>{{ file.file_name }}</h5>
      </picture>
    </d-form-row>

    <d-form-row>
      <d-col>
        <vue-dropzone
          id="dropzoneFiles"
          ref="dropzoneFiles"
          :useCustomSlot="true"
          :options="dropzoneOptions"
          @vdropzone-files-added="addFiles"
          @vdropzone-removed-file="removedFile"
        >
          <div class="dropzone-custom-content">
            <div class="dropzone-custom-content">
              <h5 class="m-0">Clique ou arraste os arquivos aqui</h5>
            </div>
          </div>
        </vue-dropzone>
      </d-col>
    </d-form-row>

    <image-preview-modal
      :images="imageUrls"
      :visible="showModal"
      :current-index.sync="previewIndex"
      @close="showModal = false"
    />

  </section>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import vue2Dropzone from 'vue2-dropzone';
import SampleService from '_services/rest/modules/sample';
import ImagePreviewModal from '../Modal/ImagePreviewModal.vue';
import { CHARACTERIZATION, _CLEAR_FILES_ } from '../SampleModel';


export default {
  name: 'sample-caracterization',
  components: {
    vueDropzone: vue2Dropzone,
    ImagePreviewModal,
  },
  props: {
    caracterization: {
      type: Object,
      default: () => CHARACTERIZATION,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        uploadMultiple: true,
        addRemoveLinks: true,
        autoProcessQueue: false,
        showCancelButton: false,
        createImageThumbnails: true,
        acceptedFiles: 'image/*',
        dictInvalidFileType: 'Você não pode enviar arquivos desse tipo.',
        dictRemoveFile: 'Remover arquivo',
        dictCancelUpload: 'Cancelar envio',
      },
      showModal: false,
      previewIndex: 0,
    };
  },
  computed: {
    model: {
      images: [],
      get() {
        return this.caracterization || cloneDeep(CHARACTERIZATION);
      },
      set(value) {
        if (value) {
          this.$emit('update:caracterization', value);
        }
      },
    },
    imageUrls() {
      return (this.model.files || []).map(f => f.url);
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    addFiles(files) {
      if (!files) return;
      this.model.images = this.model.images || [];

      const processFiles = Array.from(files).map(file => {
        if (file.type && file.type.startsWith('image/')) {
          return this.readAndRotateImage(file)
            .then(image => this.model.images.push(image))
            .catch(error => {
              this.activeAlert({ message: `Erro ao processar imagem: ${error}`, theme: 'danger' });
            });
        }
        this.activeAlert({ message: `Tipo de arquivo não suportado: ${file.type}`, theme: 'warning' });
        return Promise.resolve();
      });

      Promise.all(processFiles)
        .then(() => this.$emit('update:model', this.model))
        .catch(error => this.activeAlert({ message: `Erro ao processar arquivos: ${error}`, theme: 'danger' }));
    },

    readAndRotateImage(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = async event => {
          const image = await this.rotateImage(event.target.result);
          resolve(image);
        };
        reader.readAsDataURL(file);
      });
    },

    rotateImage(dataUrl) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          // Get the rotated image data and create a new Blob
          const rotatedImage = canvas.toDataURL('image/jpeg', 1);
          const mime = dataUrl.match(/:(.*?);/)?.[1];
          const bstr = atob(rotatedImage.split(',')[1]);
          const u8arr = new Uint8Array(bstr.length);
          for (let i = 0; i < bstr.length; i += 1) {
            u8arr[i] = bstr.charCodeAt(i);
          }
          const filename = 'rotated.jpg';
          const file = new File([u8arr], filename, { type: mime });
          resolve(file);
        };
        img.src = dataUrl;
      });
    },

    deleteFile(index) {
      const [file] = this.model.files.splice(index, 1);
      SampleService.deleteFile(file.id)
        .then(() => {
          this.activeAlert({ message: 'Arquivo deletado com sucesso', theme: 'success' });
        });
    },
    removedFile(fileToRemove) {
      if (this.model.images) {
        const index = this.model.images.findIndex(file => file.name === fileToRemove.name);
        this.model.images.splice(index, 1);
      }
    },
    previewImage(index) {
      this.previewIndex = index;
      this.showModal = true;
    },
  },
  mounted() {
    Events.$on(_CLEAR_FILES_, () => {
      setTimeout(() => {
        const dropzone = this.$refs.dropzoneFiles;
        if (dropzone && dropzone.removeAllFiles) {
          dropzone.removeAllFiles(true);
        }
      }, 30);
    });
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-characterization {
  label {
    margin-bottom: 0;
  }
  picture {
    margin-right: 10px;
    text-align: center;
    position: relative;
    &:hover {
      .delete-img {
        display: block;
      }
    }
    .delete-img {
      position: absolute;
      top: 5px;
      right: 5px;
      color: red;
      cursor: pointer;
      font-size: 15px;
      display: none;
    }
  }
  .vue-dropzone {
    margin-top: 10px;
    border-radius: 5px;
    border-style: dashed;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .dz-details {
    white-space: normal;
    overflow: visible;
    text-overflow: ellipsis;
    font-size: 12px;
    color: #333;
    max-width: 100%;
    padding: 5px 0;
  }

  ::v-deep .dz-image img {
    max-width: 300px;
    max-height: 300px;
    width: auto;
    height: auto;
    object-fit: contain;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  ::v-deep .dz-remove {
    margin: 5px 4px;
    padding: 4px 2px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    border: 1px solid #ffffff;
    transition: 0.3s ease-in-out;
  }

  ::v-deep .dz-remove:hover {
    background: #d9534f;
    border: 1px solid #d9534f;
    color: white;
    text-decoration: none;
  }

}

</style>
